import {get, post} from '@/api';

export const scheduleApi = {
    // 获取定时任务详情
    getScheduleDetail(bot_id) {
        return get(`/bot/get_schedule/${bot_id}`);
    },
    
    // 保存或更新定时任务
    saveOrUpdateSchedule(data) {
        return post('/bot/save_or_update_schedule', data);
    }
};